import React from 'react'
import classNames from 'classnames'
import { CircularProgressbar } from 'react-circular-progressbar'
import { DEFAULT_ACCENT } from '../../utils/constants'
import './style.scss'

const Status = ({ name, isProgress, color = DEFAULT_ACCENT, isGrid }) => {

  return (
    <div className='viso-status'>
      {isProgress ?
        <span className={
          classNames(
            'viso-status__progress animate-rotation', 
            `viso-text-${color}`,
            isGrid && 'viso-status__progress--grid'
          )}
        >
          <CircularProgressbar value={50} strokeWidth={20} />
        </span>
        :
        <div className={`viso-status__indicator viso-bg-${color}`} />
      }
      <div className='viso-status__name'>{name}</div>
    </div>
  )
}

export default Status